import { render } from "./bars.vue?vue&type=template&id=879fd954"
import script from "./bars.vue?vue&type=script&lang=js"
export * from "./bars.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__